"use client";
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
import { jsx as n, jsxs as te } from "react/jsx-runtime";
import * as o from "react";
import { createElement as De } from "react";
import ue from "./generated/mistica-icons/icon-chevron-left-regular.js";
import fe from "./generated/mistica-icons/icon-chevron-right-regular.js";
import { useScreenSize as de, useTheme as he, useIsInViewport as Ge } from "./hooks.js";
import Oe from "./inline.js";
import { BaseTouchable as j } from "./touchable.js";
import z from "classnames";
import { useIsInverseVariant as Ve, ThemeVariant as _ } from "./theme-variant-context.js";
import { listenResize as me, getPrefixedDataAttributes as pe } from "./utils/dom.js";
import { isAndroid as be, isIos as ze, isRunningAcceptanceTest as _e } from "./utils/platform.js";
import { useDocumentVisibility as je } from "./utils/document-visibility.js";
import { bulletButton as Fe, bulletButtonMobile as Ke, bulletButtonTablet as Ue, bulletButtonDesktop as Ye, slideshowContainer as qe, slideshowWithBullets as Ze, slideshowPrevArrowButton as $e, slideshow as He, slideshowItem as Je, slideshowNextArrowButton as Qe, slideshowBullets as Xe, bulletActiveInverse as et, bulletInverse as tt, bulletActive as ot, bullet as st, carouselContainer as rt, carouselPrevArrowButton as lt, carousel as nt, centeredCarousel as ct, carouselWithScrollMobile as at, carouselWithScrollTablet as it, vars as B, carouselItem as ut, carouselNextArrowButton as ft, carouselBullets as dt, noCarouselBulletsDesktop as ht, noCarouselBulletsTablet as mt, noCarouselBulletsMobile as pt } from "./carousel.css-mistica.js";
import { vars as bt } from "./image.css-mistica.js";
import { useDesktopContainerType as gt } from "./desktop-container-type-context.js";
import { VIVO_NEW_SKIN as vt } from "./skins/constants.js";
import { applyCssVars as ge } from "./utils/css.js";
import { ResetResponsiveLayout as xt } from "./responsive-layout.js";
const ve = (t, e)=>{
    const s = je();
    return Ge(e, !1) && s && !!t;
}, xe = (param)=>{
    let { currentIndex: t, numPages: e, onPress: s } = param;
    var _e_tablet;
    const r = Ve(), { isDesktopOrBigger: i } = de(), h = (u)=>{
        const f = u === t;
        return r ? f ? et : tt : f ? ot : st;
    }, w = typeof e == "number" ? e : Math.max(e.mobile, (_e_tablet = e.tablet) !== null && _e_tablet !== void 0 ? _e_tablet : e.mobile, e.desktop);
    return /* @__PURE__ */ n(Oe, {
        space: 0,
        alignItems: "center",
        dataAttributes: {
            "component-name": "PageBullets"
        },
        children: Array.from({
            length: w
        }, (u, f)=>/* @__PURE__ */ {
            var _e_tablet;
            return n(j, {
                className: z(typeof e == "number" ? Fe : {
                    [Ke]: f < e.mobile,
                    [Ue]: f < ((_e_tablet = e.tablet) !== null && _e_tablet !== void 0 ? _e_tablet : e.mobile),
                    [Ye]: f < e.desktop
                }),
                style: f === 0 ? {
                    paddingLeft: 0
                } : {},
                maybe: !0,
                onPress: i && s ? ()=>s(f) : void 0,
                children: /* @__PURE__ */ n("div", {
                    className: h(f)
                })
            }, f);
        })
    });
}, oe = ()=>{
    throw new Error("You must wrap your component with a CarouselContextProvider to use CarouselContext");
}, Ce = oe, Pe = oe, we = oe, Ie = {
    currentIndex: 0,
    numPages: 0
}, se = /*#__PURE__*/ o.createContext({
    goPrev: Ce,
    goNext: Pe,
    goToPage: we,
    bulletsProps: Ie
}), re = /*#__PURE__*/ o.createContext(null), zt = (param)=>{
    let { children: t } = param;
    const [e, s] = o.useState(Ie), r = o.useRef(Ce), i = o.useRef(Pe), h = o.useRef(we), w = o.useMemo(()=>({
            goPrev: ()=>{
                r.current();
            },
            goNext: ()=>{
                i.current();
            },
            goToPage: function(u) {
                let f = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : !0;
                h.current(u, f);
            },
            bulletsProps: e
        }), [
        e
    ]);
    return /* @__PURE__ */ n(se.Provider, {
        value: w,
        children: /* @__PURE__ */ n(re.Provider, {
            value: {
                setGoPrev: (u)=>{
                    r.current = u;
                },
                setGoNext: (u)=>{
                    i.current = u;
                },
                setGoToPage: (u)=>{
                    h.current = u;
                },
                setBulletsProps: s
            },
            children: t
        })
    });
}, _t = ()=>o.useContext(se), jt = se.Consumer, ae = (t, e, s)=>s ? typeof s == "number" ? s : s[t] || e[t] : e[t], Ct = (t, e)=>{
    const s = {
        mobile: 1,
        tablet: 2,
        desktop: {
            small: 1,
            medium: 2,
            large: 3
        }
    };
    if (!e) return _object_spread_props(_object_spread({}, s), {
        desktop: ae(t, s.desktop)
    });
    if (typeof e == "number") return {
        mobile: e,
        tablet: e,
        desktop: e
    };
    const r = ae(t, s.desktop, e.desktop);
    return _object_spread_props(_object_spread({}, s, e), {
        desktop: r
    });
}, ie = (t, e)=>{
    if (t.length === 0) return [];
    const s = Math.ceil(t.length / e), r = [];
    for(let i = 0; i < t.length; i += s)r.push(t[i]);
    return r[r.length - 1] = t[t.length - s], r;
}, Pt = (t, e)=>{
    const s = [];
    for(let r = 0; r < e.length; r++)r === 0 ? s.push(e[0]) : s.push((e[r] + e[r - 1]) / 2);
    for(let r = s.length - 1; r >= 0; r--)if (t - s[r] >= -1) return r;
    return 0;
}, ke = 5e3, Me = (param)=>{
    let { items: t, itemStyle: e, itemClassName: s, withBullets: r, renderBullets: i, initialActiveItem: h, itemsPerPage: w, itemsToScroll: u, mobilePageOffset: f, gap: C, free: b, centered: N, autoplay: x, onPageChange: y, dataAttributes: W } = param;
    const { texts: I, platformOverrides: S, skinName: H } = he(), J = gt(), a = Ct(J || "large", w), { isDesktopOrBigger: R, isTablet: A } = de(), F = A ? a.tablet : a.mobile, P = Math.max(Math.floor(R ? a.desktop : F), 1), l = o.useRef(null), m = Math.ceil(t.length / Math.max(Math.floor(a.mobile), 1)), v = Math.ceil(t.length / Math.max(Math.floor(a.tablet), 1)), k = Math.ceil(t.length / Math.max(Math.floor(a.desktop), 1)), E = Math.ceil(t.length / P), [{ scrollLeft: D, scrollRight: G }, Re] = o.useState({
        scrollLeft: 0,
        scrollRight: 0
    }), [Q, Ee] = o.useState([]), K = o.useMemo(()=>ie(Q, E), [
        Q,
        E
    ]), U = u ? ie(Q, Math.ceil(t.length / u)) : K, Le = G !== 0, Te = D !== 0;
    o.useEffect(()=>{
        if (l.current) {
            const c = l.current, d = ()=>{
                const { scrollWidth: q, clientWidth: V } = c, Z = Math.round(c.scrollLeft), $ = Math.round(q - (Z + V));
                Re({
                    scrollLeft: Z,
                    scrollRight: $
                });
            }, p = ()=>{
                const q = c.scrollWidth - c.clientWidth;
                Ee(Array.from(c.querySelectorAll("[data-item]")).map((V, Z)=>{
                    if (Z === t.length - 1) return q;
                    const $ = V.offsetLeft, We = parseInt(getComputedStyle(V).scrollMargin), Ae = N && !R ? $ - V.clientWidth / 2 : $;
                    return Math.min(Ae - We - c.offsetLeft, q);
                }));
            };
            d(), p(), c.addEventListener("scroll", d);
            const g = me(c, ()=>{
                d(), p();
            });
            return ()=>{
                c.removeEventListener("scroll", d), g();
            };
        }
        return ()=>{};
    }, [
        a.desktop,
        a.tablet,
        a.mobile,
        E,
        C,
        N,
        R,
        t.length
    ]);
    const L = o.useCallback(function(c) {
        let d = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : !0;
        const p = l.current;
        if (p) {
            const g = K[c];
            p.scrollTo({
                left: g,
                behavior: d ? "smooth" : "auto"
            });
        }
    }, [
        K
    ]), X = o.useCallback(()=>{
        const c = l.current;
        if (c) {
            const { scrollLeft: d } = c, p = [
                ...U
            ].reverse().find((g)=>g - d < -1);
            c.scrollTo({
                left: p,
                behavior: "smooth"
            });
        }
    }, [
        U
    ]), O = o.useCallback(()=>{
        const c = l.current;
        if (c) {
            const { scrollLeft: d } = c, p = U.find((g)=>g - d > 1);
            c.scrollTo({
                left: p,
                behavior: "smooth"
            });
        }
    }, [
        U
    ]), le = ve(!!x, l);
    o.useEffect(()=>{
        h !== void 0 && L(Math.floor(h / P), !1);
    }, [
        h,
        L,
        P
    ]), o.useEffect(()=>{
        if (le && x) {
            const c = typeof x == "boolean" ? ke : x.time, d = typeof x == "object" && x.loop, p = setInterval(()=>{
                var g;
                G !== 0 ? O() : d && ((g = l.current) == null || g.scrollTo({
                    left: 0,
                    behavior: "smooth"
                }));
            }, c);
            return ()=>clearInterval(p);
        }
    }, [
        x,
        O,
        G,
        le
    ]);
    const M = Pt(D, K), ne = o.useRef(!h), ce = o.useRef(0);
    o.useEffect(()=>{
        if (y) {
            const c = Math.min((M + 1) * P - 1, t.length - 1), d = [];
            for(let p = 0; p < P; p++){
                const g = c - p;
                g >= 0 && d.unshift(g);
            }
            ne.current ? ce.current !== M && y({
                pageIndex: M,
                shownItemIndexes: d
            }) : ne.current = d.includes(h || 0), ce.current = M;
        }
    }, [
        M,
        t.length,
        P,
        h,
        y
    ]);
    const T = o.useContext(re), ee = o.useMemo(()=>({
            currentIndex: M,
            numPages: {
                mobile: m,
                tablet: v,
                desktop: k
            }
        }), [
        M,
        k,
        m,
        v
    ]);
    o.useEffect(()=>{
        T && (T.setGoPrev(X), T.setGoNext(O), T.setGoToPage(L), T.setBulletsProps(ee));
    }, [
        T,
        O,
        X,
        ee,
        L
    ]);
    let Y = null;
    i ? Y = i({
        numPages: E,
        currentIndex: M,
        onPress: L
    }) : r && (Y = /* @__PURE__ */ n(xe, _object_spread_props(_object_spread({}, ee), {
        onPress: L
    })));
    const Be = "64px", ye = "36px";
    return /* @__PURE__ */ te("div", _object_spread_props(_object_spread({}, pe(_object_spread({
        "component-name": "Carousel"
    }, W))), {
        children: [
            /* @__PURE__ */ te("div", {
                className: rt,
                children: [
                    /* @__PURE__ */ n(_, {
                        isInverse: !1,
                        children: /* @__PURE__ */ n(j, {
                            className: lt,
                            "aria-label": I.carouselPrevButton,
                            onPress: X,
                            disabled: !Te,
                            children: /* @__PURE__ */ n(ue, {})
                        })
                    }),
                    /* @__PURE__ */ n("div", {
                        className: z(nt, {
                            [ct]: N,
                            [at]: m > 1,
                            [it]: v > 1
                        }),
                        style: _object_spread_props(_object_spread({}, ge(_object_spread({
                            [B.itemsPerPageDesktop]: String(a.desktop),
                            [B.itemsPerPageTablet]: String(a.tablet),
                            [B.itemsPerPageMobile]: String(a.mobile)
                        }, f === "large" ? {
                            [B.mobilePageOffset]: Be
                        } : H === vt ? {
                            [B.mobilePageOffset]: ye
                        } : {}, C !== void 0 ? {
                            [B.gap]: String(C)
                        } : {}))), {
                            scrollSnapType: b ? "initial" : "x mandatory",
                            // Hack to fix https://jira.tid.es/browse/NOVUMCC-8988
                            // there is a webkit rendering bug that causes a half pixel white line to appear at
                            // the bottom of the scrollable area in retina displays when it has a height with
                            // decimals. This extra padding avoids that line to partially cover the carousel
                            // slides border:
                            paddingBottom: ze(S) && !_e(S) ? 0.5 : void 0
                        }),
                        ref: l,
                        children: t.map((c, d)=>/* @__PURE__ */ n("div", {
                                className: z(ut, s),
                                style: _object_spread_props(_object_spread({}, e), {
                                    scrollSnapStop: be(S) ? "always" : "normal"
                                }),
                                "data-item": !0,
                                children: c
                            }, d))
                    }),
                    /* @__PURE__ */ n(_, {
                        isInverse: !1,
                        children: /* @__PURE__ */ n(j, {
                            className: ft,
                            "aria-label": I.carouselNextButton,
                            onPress: O,
                            disabled: !Le,
                            children: /* @__PURE__ */ n(fe, {})
                        })
                    })
                ]
            }),
            Y && /* @__PURE__ */ n("div", {
                className: z(dt, // when renderBullets is provided, we let the consumer decide if the bullets should be hidden
                !i && {
                    [ht]: k <= 1,
                    [mt]: v <= 1,
                    [pt]: m <= 1
                }),
                children: Y
            })
        ]
    }));
}, Ne = ()=>{
    const [t, e] = o.useState(1);
    return o.useEffect(()=>{
        const s = ()=>{
            window.innerWidth !== 0 && (e((r)=>r + 1), window.removeEventListener("resize", s));
        };
        return window.innerWidth === 0 && window.addEventListener("resize", s), ()=>{
            window.removeEventListener("resize", s);
        };
    }, []), t;
}, Ft = (t)=>{
    const e = Ne();
    return /* @__PURE__ */ /*#__PURE__*/ De(Me, _object_spread_props(_object_spread({}, t), {
        key: e
    }));
}, Kt = (param)=>{
    let { items: t, itemStyle: e, itemClassName: s, withBullets: r, renderBullets: i, initialActiveItem: h, onPageChange: w, dataAttributes: u } = param;
    const f = Ne();
    return /* @__PURE__ */ n(Me, {
        items: t,
        itemStyle: e,
        itemClassName: s,
        itemsPerPage: {
            mobile: 1,
            tablet: 1,
            desktop: 3
        },
        centered: !0,
        itemsToScroll: 1,
        gap: 0,
        withBullets: r,
        renderBullets: i,
        initialActiveItem: h,
        onPageChange: w,
        dataAttributes: u
    }, f);
}, Se = /*#__PURE__*/ o.createContext(void 0), Ut = ()=>o.useContext(Se), Yt = (param)=>{
    let { items: t, withBullets: e, autoplay: s, initialPageIndex: r = 0, onPageChange: i, dataAttributes: h, inverseBullets: w = !0 } = param;
    const { texts: u, platformOverrides: f } = he(), C = o.useContext(re), b = o.useRef(null), [{ scrollLeft: N, scrollRight: x }, y] = o.useState({
        scrollLeft: 0,
        scrollRight: 0
    }), W = o.useCallback(()=>{
        const l = b.current;
        l && l.scrollBy({
            left: -l.clientWidth,
            behavior: "smooth"
        });
    }, []), I = o.useCallback(()=>{
        const l = b.current;
        l && l.scrollBy({
            left: l.clientWidth,
            behavior: "smooth"
        });
    }, []), S = o.useCallback(function(l) {
        let m = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : !0;
        const v = b.current;
        v && v.scrollTo({
            left: v.clientWidth * l,
            behavior: m ? "smooth" : "auto"
        });
    }, [
        b
    ]), H = x !== 0, J = N !== 0, a = b.current ? Math.floor((N + b.current.clientWidth / 2) / b.current.clientWidth) : 0;
    o.useLayoutEffect(()=>{
        const l = b.current;
        if (l) {
            const m = ()=>{
                const { scrollWidth: k, clientWidth: E } = l, D = Math.round(l.scrollLeft), G = Math.round(k - (D + E));
                y({
                    scrollLeft: D,
                    scrollRight: G
                });
            };
            m(), l.addEventListener("scroll", m);
            const v = me(l, m);
            return ()=>{
                l.removeEventListener("scroll", m), v();
            };
        }
    }, [
        t.length
    ]);
    const R = ve(!!s, b);
    o.useEffect(()=>{
        if (R && s) {
            const l = typeof s == "boolean" ? ke : s.time, m = typeof s == "object" && s.loop, v = setInterval(()=>{
                var k;
                x !== 0 ? I() : m && ((k = b.current) == null || k.scrollTo({
                    left: 0,
                    behavior: "smooth"
                }));
            }, l);
            return ()=>clearInterval(v);
        }
    }, [
        s,
        I,
        x,
        R
    ]);
    const A = o.useRef(!1), F = o.useRef(0);
    o.useEffect(()=>{
        i && (A.current ? F.current !== a && i(a) : A.current = r === a), F.current = a;
    }, [
        a,
        r,
        i
    ]), o.useEffect(()=>{
        const l = b.current;
        r !== void 0 && l && !A.current && l.scrollTo({
            left: l.clientWidth * r
        });
    }, [
        r
    ]);
    const P = o.useMemo(()=>({
            currentIndex: a,
            numPages: t.length
        }), [
        a,
        t.length
    ]);
    return o.useEffect(()=>{
        C && (C.setGoPrev(W), C.setGoNext(I), C.setGoToPage(S), C.setBulletsProps(P));
    }, [
        C,
        I,
        W,
        P,
        S
    ]), /* @__PURE__ */ n(Se.Provider, {
        value: {
            withBullets: !!e
        },
        children: /* @__PURE__ */ n(xt, {
            skipDesktop: !0,
            children: /* @__PURE__ */ te("div", _object_spread_props(_object_spread({
                className: z(qe, {
                    [Ze]: !!e
                })
            }, pe(h, "SlideShow")), {
                children: [
                    /* @__PURE__ */ n(_, {
                        isInverse: !1,
                        children: /* @__PURE__ */ n(j, {
                            className: $e,
                            "aria-label": u.carouselPrevButton,
                            onPress: W,
                            disabled: !J,
                            children: /* @__PURE__ */ n(ue, {})
                        })
                    }),
                    /* @__PURE__ */ n("div", {
                        style: ge({
                            [bt.mediaBorderRadius]: "0px"
                        }),
                        children: /* @__PURE__ */ n("div", {
                            className: He,
                            ref: b,
                            children: t.map((l, m)=>/* @__PURE__ */ n("div", {
                                    className: Je,
                                    style: {
                                        scrollSnapStop: be(f) ? "always" : "normal"
                                    },
                                    children: l
                                }, m))
                        })
                    }),
                    /* @__PURE__ */ n(_, {
                        isInverse: !1,
                        children: /* @__PURE__ */ n(j, {
                            className: Qe,
                            "aria-label": u.carouselNextButton,
                            onPress: I,
                            disabled: !H,
                            children: /* @__PURE__ */ n(fe, {})
                        })
                    }),
                    e && t.length > 1 && /* @__PURE__ */ n(_, {
                        isInverse: w,
                        children: /* @__PURE__ */ n("div", {
                            className: Xe,
                            children: /* @__PURE__ */ n(xe, _object_spread({}, P))
                        })
                    })
                ]
            }))
        })
    });
};
export { Ft as Carousel, jt as CarouselContextConsumer, zt as CarouselContextProvider, Kt as CenteredCarousel, xe as PageBullets, Yt as Slideshow, _t as useCarouselContext, Ut as useSlideshowContext };
